import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { takeEvery, takeLatest, put } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { CLOSET_PROMOTIONS_COUNT, CLOSET_PROMOTIONS_ITEM_COUNT, UiState } from 'constants/index';
import * as api from 'data/api';
import { transformClosets } from 'data/transformers/closet';
import { transformClosetPromotionOrder, transformClosetPromotionMotivation } from 'data/transformers/closet-promotion';
import { transformClosetPromotionPricingResponse } from 'data/api/transformers/response';
import { getFilters, getSearchSessionId, getSelectedDynamicFilters } from 'state/catalog-filters/selectors';
import { tracker } from 'libs/common/tracker';
import { clickEvent } from 'libs/common/event-tracker/events';
import { actions } from './slice';
import * as statelessActions from './actions';
import { getSeenClosetIds, getOrderPrepareUiState } from './selectors';
export function* getClosetPromotions(_ref) {
  let {
    payload
  } = _ref;
  const filters = yield* select(getFilters);
  const selectedDynamicFilters = (payload === null || payload === void 0 ? void 0 : payload.selectedDynamicFilters) || (yield* select(getSelectedDynamicFilters));
  const searchSessionId = (payload === null || payload === void 0 ? void 0 : payload.searchSessionId) || (yield* select(getSearchSessionId));
  const excludedUserIds = yield* select(getSeenClosetIds);
  const response = yield* call(api.getClosetPromotions, _objectSpread(_objectSpread(_objectSpread({
    excludedUserIds,
    perPage: CLOSET_PROMOTIONS_COUNT,
    itemCount: CLOSET_PROMOTIONS_ITEM_COUNT,
    searchSessionId
  }, filters), payload), {}, {
    selectedDynamicFilters
  }));

  if ('errors' in response) {
    yield put(actions.getClosetPromotionsFailure());
    return;
  }

  yield put(actions.getClosetPromotionsSuccess({
    closets: transformClosets(response.promoted_closets)
  }));
}
export function* getPricing() {
  const response = yield* call(api.getClosetPromotionPricing);

  if ('errors' in response) {
    yield put(actions.getPricingFailure());
    return;
  }

  yield put(actions.getPricingSuccess({
    pricing: transformClosetPromotionPricingResponse(response)
  }));
}
export function* prepareClosetPromotionOrder() {
  const response = yield* call(api.prepareClosetPromotionOrder);

  if ('errors' in response) {
    yield put(actions.prepareClosetPromotionOrderFailure());
    return;
  }

  const {
    motivation,
    closet_promotion_order
  } = response.closet_promotion;
  yield put(actions.prepareClosetPromotionOrderSuccess({
    order: transformClosetPromotionOrder(closet_promotion_order),
    motivation: motivation && transformClosetPromotionMotivation(motivation)
  }));
}
export function* getClosetPromotionOrder(_ref2) {
  let {
    payload: {
      closetPromotionOrderId
    }
  } = _ref2;
  const response = yield* call(api.getClosetPromotionOrder, closetPromotionOrderId);

  if ('errors' in response) {
    yield put(actions.getClosetPromotionOrderFailure());
    return;
  }

  const closetPromotionOrder = transformClosetPromotionOrder(response.closet_promotion_order);
  yield put(actions.getClosetPromotionOrderSuccess({
    closetPromotionOrder
  }));
}
export function* proceedToCheckout() {
  const orderPrepareUiState = yield* select(getOrderPrepareUiState);

  if (orderPrepareUiState !== UiState.Success) {
    yield put(actions.prepareClosetPromotionOrderRequest());
  }
}
export function* startPreCheckout() {
  tracker.track(clickEvent({
    target: ClickableElement.PromoteCloset
  }));
  yield put(actions.getPricingRequest());
}
export default function* saga() {
  yield takeEvery(actions.getClosetPromotionsRequest, getClosetPromotions);
  yield takeLatest(actions.startPreCheckout.type, startPreCheckout);
  yield takeLatest(actions.getClosetPromotionOrderRequest.type, getClosetPromotionOrder);
  yield takeLatest(actions.prepareClosetPromotionOrderRequest.type, prepareClosetPromotionOrder);
  yield takeLatest(actions.getPricingRequest.type, getPricing);
  yield takeLatest(statelessActions.proceedToCheckout.type, proceedToCheckout);
}